import { gql, useMutation } from '@apollo/client'
import { navigate } from '@reach/router'
import { useNotification } from '@btime/react-messager'

import { qrcodesClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpsertQrcode($input: QrcodeInput) {
    upsertQrcode(input: $input) {
      id
    }
  }
`

export const useSaveQrcode = (id, record, type) => {
  const notify = useNotification()

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Qrcode', 'Qrcodes'], client: qrcodesClient })

  const handleRequest = () => {
    const input = { id: parseInt(id), type, data: { id: record?.id }, activated: true }

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: 'QR Code ativado com sucesso!', message: 'Redirecionando para o qrcode...' })

        navigate(`/qrcodes/public/${id}`)
      } else {
        notify.error({ title: 'Ocorreu um erro ao ativar o QR Code' })
      }
    })
  }

  return [handleRequest, state]
}
